import { render, staticRenderFns } from "./CompArticleDoughnutDashboard.vue?vue&type=template&id=af1d796e&scoped=true"
import script from "./CompArticleDoughnutDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompArticleDoughnutDashboard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompArticleDoughnutDashboard.vue?vue&type=style&index=0&id=af1d796e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1d796e",
  null
  
)

export default component.exports